export enum DestinatarioTipo {
    Chat = "WORKGROUP",
    Email = "EMAIL",
}